export default "__VITE_ASSET__DHq3_uSr__"